// extracted by mini-css-extract-plugin
export default {"installStatus":"InstallStatus--installStatus--4722f9","spinner":"InstallStatus--spinner--a51e72","description":"InstallStatus--description--90206e"};